<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2>
        <v-card>
          <v-card-text>
              <h1>Contact Us</h1>
              <h2>Phone: +62 8282828 8282828</h2>
              <h2>Email: mph@mph.com</h2>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      name: 'ContactUs'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Public/ContactUs.vue